import { Profile } from "../types/Profile";
import { API_URL } from "../utils";

export default async (userId: number, lastId: number = 0): Promise<Profile> => {
	const result: { data: Profile } = await (await fetch(`${API_URL}/users/user?id=${userId}&lastId=${lastId}`, {
		credentials: 'include'
	})).json();

	return result.data;
}